import React from 'react';

export default function Detail({ isOpen, onClose, data }) {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

const convertToEmbedUrl = (url) => {
  if (!url || url.trim() === '') return null;
  
  try {
    if (url.includes('youtube.com/embed/')) {
      return url;
    }
    
    const patterns = [
      // https://www.youtube.com/watch?v=VIDEO_ID
      /(?:youtube\.com\/watch\?v=)([a-zA-Z0-9_-]{11})/,
      // https://youtu.be/VIDEO_ID
      /(?:youtu\.be\/)([a-zA-Z0-9_-]{11})/,
      // https://www.youtube.com/v/VIDEO_ID
      /(?:youtube\.com\/v\/)([a-zA-Z0-9_-]{11})/,
      // https://m.youtube.com/watch?v=VIDEO_ID
      /(?:m\.youtube\.com\/watch\?v=)([a-zA-Z0-9_-]{11})/,
      // https://www.youtube.com/shorts/VIDEO_ID (새로 추가)
      /(?:youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/,
      // https://m.youtube.com/shorts/VIDEO_ID (모바일 shorts)
      /(?:m\.youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/
    ];
    
    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match && match[1]) {
        return `https://www.youtube.com/embed/${match[1]}`;
      }
    }
    
    return url;
    
  } catch (error) {
    console.error('URL 변환 중 오류:', error);
    return null; 
  }
};

  const displayTitle = data?.title || '제목을 입력하세요';
  const displaySubtitle = data?.subtitle || '';
  const videoUrl = convertToEmbedUrl(data?.videoUrl || data?.url || data?.e_url);
  const content = data?.content || '내용을 입력하세요';

  console.log('Original URL:', data?.videoUrl || data?.url || data?.e_url);
  console.log('Converted URL:', videoUrl);

  return (
    <div className="detail_overlay" onClick={handleBackdropClick}>
      <div className="detail_popup">
        <button className="detail_close_btn" onClick={onClose}>
          ×
        </button>

        <div className="detail_header txt-center pt-5 pb-5 mb-5">
          <h2 className="detail_title prt-semi-bold fs-24 fc-black1 mb-2">
            {displayTitle}
          </h2>
          <p className="detail_subtitle prt-light fs-15 fc-005eed">
            {displaySubtitle}
          </p>
        </div>

        <div className="detail_content">
          <div className="detail_media">
            {videoUrl && (
              <div className="media_container mb-4">
                <iframe
                  className="w-100 h-100"
                  src={videoUrl}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; 
              encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            )}
            <p className="media_caption prt-media fs-16 fc-black1">{content}</p>
          </div>
        </div>
      </div>
    </div>
  );
}